var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"my-4"},[_c('v-card-text',{staticClass:"py-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"9"}},[_vm._v(" "+_vm._s(_vm.today)+" "+_vm._s(_vm.currentFinancialYear)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }